module.exports = __webpack_public_path__ + "static/media/iconK.feaf99bb.svg";